import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-i-remote-pay',
  templateUrl: './i-remote-pay.component.html',
  styleUrls: ['./i-remote-pay.component.css']
})
export class IRemotePayComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }
  base_url = this.generalService.BASE_URL;
  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/i-remote-pay/i-remote-pay.component.ts